import Model from '@/Models/Contracts/Model';
export default class FieldConfiguration extends Model {
    resource() {
        return 'field-configurations';
    }
}
